import React from 'react';
import PropTypes from 'prop-types';

import MerchantClickUrlLink from 'core/modules/MerchantClickUrlLink/MerchantClickUrlLink';
import FavoriteIcon from 'core/modules/FavoriteIcon/FavoriteIcon';
import PremierMerchantRebate from 'core/modules/PremierMerchantRebate/PremierMerchantRebate';
import MerchantExperienceLink from 'core/modules/MerchantExperienceLink/MerchantExperienceLink';

import './MultipleMerchantsItemGSP.scss';

function MultipleMerchantsItemGSP({ merchant, config }) {
  const {
    id,
    name,
    logoUrls,
    showRebate,
    rebate,
    isSuspended,
    isDeactivated,
  } = merchant;

  const { rebateOptions, useAddToFavorite } = config;
  const isActive = !isSuspended && !isDeactivated;

  return (
    <div className="merchantItem">
      <div className="mn_merchantInfoWrap">
        {useAddToFavorite && (
          <div className="mn_merchantFavoriteWrap">
            <FavoriteIcon merchantId={id} merchantName={name} />
          </div>
        )}
        <div className="mn_infoWrap">
          <MerchantExperienceLink merchant={merchant} className="mn_moreLinkInActiveMerchant">
            {logoUrls ? <img className="mn_logo" src={logoUrls._120x60} alt={name} /> :
            <div className="mn_merchantName">{name}</div>}
          </MerchantExperienceLink>
          {isActive ? (showRebate && (
            <div className="mn_merchantItemFooter">
              <PremierMerchantRebate {...rebate} {...rebateOptions} showRebateInline />
            </div>
          )) : <p className="mn_noRebate">No reward</p>}
        </div>
        {isActive ?
          <MerchantClickUrlLink className="mn_button mn_secondaryButton mn_shopNowLink" merchant={merchant}>
            Shop now
          </MerchantClickUrlLink>
          :
          <MerchantExperienceLink merchant={merchant} className="mn_moreLinkInActiveMerchant">
            Learn more
          </MerchantExperienceLink>
        }
      </div>
    </div>
  );
}

MultipleMerchantsItemGSP.propTypes = {
  merchant: PropTypes.shape({}).isRequired,
  config: PropTypes.shape({}),
};

MultipleMerchantsItemGSP.defaultProps = {
  config: {},
};

export default MultipleMerchantsItemGSP;
